import { ILoginUser } from '../../common/interfaces/dtos/ILoginUser';
import { forceSignOffService } from './service/force-sign-off-service';
import { signOff } from './sign-off';

export const forceSignOff = async (
  loginInputParams: ILoginUser,
  trainingMode: boolean,
  iamSignOff?: () => any,
): Promise<void> => {
  await forceSignOffService(loginInputParams).then(
    async (): Promise<void> => {
      await signOff(trainingMode, true, iamSignOff);
    },
  );
};
